<app-background-animation></app-background-animation>
<div class="login-container">
    <div class="background-image"></div>
    <div class="login-card" [ngClass]="showRegister ? 'register' : ''">
        <mat-card>
            <mat-card-header>
                <div class="rotating-logo"></div>
            </mat-card-header>
            <mat-card-content>
                <ng-container *ngIf="!showRegister && !showForgot">
                    <h2>Login</h2>
                    <form [formGroup]="loginForm" (ngSubmit)="onLogin()" autocomplete="on" name="login">
                        <mat-form-field appearance="outline">
                            <mat-label>Email</mat-label>
                            <input matInput type="email" formControlName="email" required
                                id="login-email" name="email" autocomplete="username"
                                autocapitalize="off" spellcheck="false" inputmode="email">
                            <mat-error *ngIf="loginForm.get('email')?.invalid">Please enter a valid email</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Password</mat-label>
                            <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="password" required
                                id="login-password" name="password" autocomplete="current-password">
                            <button mat-icon-button matSuffix (click)="showPassword = !showPassword" type="button" attr.aria-label="{{ showPassword ? 'Hide password' : 'Show password' }}">
                                <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                            <mat-error *ngIf="loginForm.get('password')?.invalid">Please enter your password</mat-error>
                        </mat-form-field>
                        <div class="forgot-password">
                            <a (click)="showForgot = true" color="primary">Forgot Password?</a>
                        </div>
                        <!-- Disabled while a login is in flight. The visible label change matters as
                             much as the disabled state: the only other progress indicator is a 4px
                             bar at the very top of the viewport, which users miss, so they clicked
                             Login again believing nothing had happened. -->
                        <button mat-raised-button color="primary" type="submit" [disabled]="isLoggingIn">
                            {{ isLoggingIn ? 'Signing in…' : 'Login' }}
                        </button>
                    </form>
                    <div class="register-link" *ngIf="!isNative">
                        Don't have an account? <a (click)="showRegister = true">Register</a>
                    </div>
                </ng-container>
                <ng-container *ngIf="showRegister">
                    <app-register (loginClick)="onRegisterSuccess($event)" [patchEmail]="patchEmail"
                        [patchType]="patchType"></app-register>
                </ng-container>
                <ng-container *ngIf="showForgot">
                    <app-forgot-password (loginClick)="onForgotPasswordSuccess()"></app-forgot-password>
                </ng-container>
            </mat-card-content>
        </mat-card>
    </div>
</div>